import React from 'react';
import {
  indicatorsContainer,
  dotBase,
  dotActive,
  dotInactive,
  dotActiveLight,
  dotInactiveLight,
  combineCarouselClasses,
} from './carousel.styles';
import type { CarouselIndicatorsProps, CarouselIndicatorVariant } from './types';

const dotStyles: Record<CarouselIndicatorVariant, { active: string; inactive: string }> = {
  default: { active: dotActive, inactive: dotInactive },
  light: { active: dotActiveLight, inactive: dotInactiveLight },
};

export const CarouselIndicators = React.forwardRef<HTMLDivElement, CarouselIndicatorsProps>(
  ({ currentPage, totalPages, onPageSelect, variant = 'default', className, ...restProps }, ref) => {
    const dots = dotStyles[variant];

    if (totalPages <= 1) return null;

    return (
      <div
        ref={ref}
        role="tablist"
        aria-label="Carousel pages"
        className={combineCarouselClasses(indicatorsContainer, className)}
        {...restProps}
      >
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            type="button"
            role="tab"
            aria-selected={i === currentPage}
            aria-label={`Go to page ${i + 1}`}
            className={combineCarouselClasses(dotBase, i === currentPage ? dots.active : dots.inactive)}
            onClick={() => onPageSelect(i)}
          />
        ))}
      </div>
    );
  },
);

CarouselIndicators.displayName = 'CarouselIndicators';
